module.exports = __webpack_public_path__ + "img/7_196.ed287b3f.png";